import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderByIdController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderByIdController.php
* @route '/api/supplier-order/{supplier_order}'
*/
const GetSupplierOrderByIdController = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSupplierOrderByIdController.url(args, options),
    method: 'get',
})

GetSupplierOrderByIdController.definition = {
    methods: ["get","head"],
    url: '/api/supplier-order/{supplier_order}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderByIdController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderByIdController.php
* @route '/api/supplier-order/{supplier_order}'
*/
GetSupplierOrderByIdController.url = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order: typeof args.supplier_order === 'object'
        ? args.supplier_order.id
        : args.supplier_order,
    }

    return GetSupplierOrderByIdController.definition.url
            .replace('{supplier_order}', parsedArgs.supplier_order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderByIdController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderByIdController.php
* @route '/api/supplier-order/{supplier_order}'
*/
GetSupplierOrderByIdController.get = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSupplierOrderByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderByIdController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderByIdController.php
* @route '/api/supplier-order/{supplier_order}'
*/
GetSupplierOrderByIdController.head = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSupplierOrderByIdController.url(args, options),
    method: 'head',
})

export default GetSupplierOrderByIdController